export type AppColor =
    'primary'
    | 'primary_tone1'
    | 'success'
    | 'success_tone1'
    | 'booking_arriving'
    | 'booking_leaving'
    | 'warning'
    | 'warning_tone1'
    | 'danger'
    | 'danger_tone1'
    | 'purple'
    | 'purple_tone1'
    | 'bg'
    | 'bg_login'
    | 'bg_gradient'
    | 'bg_gradient2'
    | 'bg_splash_screen'
    | 'bg_tone1'
    | 'bg_tone3'
    | 'br'
    | 'header'
    | 'header_transparent'
    | 'tabs'
    | 'tabs_transparent'
    | 'text'
    | 'text_invert'
    | 'gray'
    | 'gray_tone2'
    | 'white'
    | 'light'
    | 'indicator'
    | 'indicator_invert'
    | 'card_bg';

export const appLightColors: { key: AppColor, value: string }[] = [
    { key: 'primary', value: 'hsla(228, 48%, 48%)' },
    { key: 'primary_tone1', value: 'hsla(228, 48%, 48%, 0.1)' },
    { key: 'success', value: 'hsla(114, 55%, 45%)' },
    { key: 'success_tone1', value: 'hsla(114, 55%, 45%, 0.1)' },
    { key: 'booking_arriving', value: 'rgba(25, 171, 12, 1)' },
    { key: 'booking_leaving', value: 'hsla(356, 100%, 39%)' },
    { key: 'warning', value: 'hsla(40, 87%, 50%)' },
    { key: 'warning_tone1', value: 'hsla(40, 87%, 50%, 0.1)' },
    { key: 'danger', value: 'hsla(356, 100%, 39%)' },
    { key: 'danger_tone1', value: 'hsla(356, 100%, 39%, 0.1)' },
    { key: 'purple', value: 'hsla(330, 100%, 39%)' },
    { key: 'purple_tone1', value: 'hsla(330, 100%, 39%, 0.1)' },
    { key: 'bg', value: '#EFF2F4' },
    { key: 'bg_login', value: 'transparent' },
    { key: 'bg_gradient', value: 'linear-gradient(to bottom, hsla(204 18.5% 94.7% / 1), transparent, transparent' },
    { key: 'bg_gradient2', value: 'linear-gradient(to bottom, hsla(204 18.5% 94.7% / 1), hsla(204 18.5% 94.7% / 0.3)' },
    { key: 'bg_splash_screen', value: 'transparent' },
    { key: 'bg_tone1', value: 'white' },
    { key: 'bg_tone3', value: 'white' },
    { key: 'br', value: '#e9eef4ff' },
    { key: 'header', value: '#EFF2F4' },
    { key: 'header_transparent', value: 'hsla(206 68.7% 42.5% / 0.88)' },
    { key: 'tabs', value: 'white' },
    { key: 'tabs_transparent', value: 'white' },
    { key: 'text', value: 'black' },
    { key: 'text_invert', value: 'white' },
    { key: 'gray', value: 'hsla(0 100% 0% / 0.7)' },
    { key: 'gray_tone2', value: '#DEDEDE' },
    { key: 'white', value: 'white' },
    { key: 'light', value: 'hsla(0 100% 100% / 0.7)' },
    { key: 'indicator', value: 'white' },
    { key: 'indicator_invert', value: '#4948bc' },
    { key: 'card_bg', value: '#ebebeb' },
]

export const appDarkColors: { key: AppColor, value: string }[] = [
    { key: 'primary', value: 'hsla(212, 100%, 45%)' },
    { key: 'primary_tone1', value: 'hsla(212, 100%, 45%, 0.1)' },
    { key: 'success', value: 'hsla(114, 100%, 32%)' },
    { key: 'success_tone1', value: 'hsla(114, 100%, 32%, 0.1)' },
    { key: 'booking_arriving', value: 'hsla(124, 92%, 30%, 1.00)' },
    { key: 'booking_leaving', value: 'hsla(0, 97%, 33%, 1.00)' },
    { key: 'warning', value: 'hsla(35, 87%, 50%)' },
    { key: 'warning_tone1', value: 'hsla(35, 87%, 50%, 0.1)' },
    { key: 'danger', value: 'hsla(356 100% 40%)' },
    { key: 'danger_tone1', value: 'hsla(356 100% 40%, 0.1)' },
    { key: 'purple', value: 'hsla(330, 100%, 39%)' },
    { key: 'purple_tone1', value: 'hsla(330, 100%, 39%, 0.1)' },
    { key: 'bg', value: '#0D0E0F' },
    { key: 'bg_login', value: 'hsla(0 0% 0% / 0.7)' },
    { key: 'bg_gradient', value: '#0D0E0F' },
    { key: 'bg_gradient2', value: '#0D0E0F' },
    { key: 'bg_splash_screen', value: 'hsla(0 0% 0% / 0.7)' },
    { key: 'bg_tone1', value: '#0D0E0F' },
    { key: 'bg_tone3', value: '#191A1C' },
    { key: 'br', value: '#222326' },
    { key: 'header', value: '#0D0E0F' },
    { key: 'header_transparent', value: 'hsla(210 7.1% 5.5% / 0.88)' },
    { key: 'tabs', value: '#0D0E0F' },
    { key: 'tabs_transparent', value: 'hsla(210 7.1% 5.5% / 0.88)' },
    { key: 'text', value: '#D7D7D7' },
    { key: 'text_invert', value: 'black' },
    { key: 'gray', value: 'hsla(0 0% 100% / 0.6)' },
    { key: 'gray_tone2', value: '#161718' },
    { key: 'white', value: '#D7D7D7' },
    { key: 'light', value: 'hsl(240 0% 60% / 0.7)' },
    { key: 'indicator', value: '#006BE6' },
    { key: 'indicator_invert', value: '#D7D7D7' },
    { key: 'card_bg', value: 'transparent' }
]